import type { ColorScheme } from '@hivewatch/dark'

export const getRulesTableToken = (colorScheme: ColorScheme, token: string) =>
  `${colorScheme === 'light' ? 'light.' : ''}${token}`
